import Typography from '@mui/material/Typography';
import { Card, CardContent } from '@mui/material';
import { getSentence } from './translations';
import HomeIcon from '@mui/icons-material/Home';



export function tutoStartMeeting()
{
    //Tutorial about how to start a new meeting.
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            height: '100%',
            padding: '20px',
        }}>
            <Card 
                elevation={3}
                sx={{ 
                    maxWidth: 600, 
                    width: '100%',
                    borderRadius: 2
                }}
            >
                <CardContent sx={{ padding: 3 }}>
                    <Typography variant="h5" >
                        {getSentence(45) + " " + getSentence(46)}
                    </Typography>
                </CardContent>
            </Card>
        </div>
      )
}


export function tutoEndMeeting()
{
    //Tutorial about how to find the recorded meeting or start a new one.
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            height: '100%',
            padding: '20px',
        }}>
            <Card 
                elevation={3}
                sx={{ 
                    maxWidth: 600, 
                    width: '100%',
                    borderRadius: 2
                }}
            >
                <CardContent sx={{ padding: 3 }}>
                    <Typography variant="h5" >
                        {getSentence(51) } <HomeIcon /> { getSentence(52)}
                    </Typography>
                </CardContent>
            </Card>
        </div>
      )
}